import React, { useEffect, useRef, useState } from 'react';
import { Icon } from '../core/Icon.jsx';

const DEFAULT_SPEEDS = [0.75, 1, 1.25, 1.5, 1.75, 2];

const fmtSpeed = (v) => v.toFixed(2).replace(/0$/, '');

/** Playback-speed button + pop menu. Shows e.g. "1.25×". */
export function SpeedControl({ value = 1, onChange, options = DEFAULT_SPEEDS, menuDirection = 'up', className = '' }) {
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const close = (e) => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener('pointerdown', close);
    return () => document.removeEventListener('pointerdown', close);
  }, [open]);

  return (
    <span className={`bjl-popwrap ${className}`} ref={ref}>
      <button
        className={`bjl-speedbtn ${open ? 'is-open' : ''}`}
        onClick={() => setOpen(!open)}
        aria-label="播放速度"
        title="播放速度"
      >
        {fmtSpeed(value)}×
      </button>
      {open ? (
        <span className={`bjl-popmenu bjl-popmenu--${menuDirection}`} role="menu">
          <span className="bjl-popmenu__label">播放速度</span>
          {options.map((s) => (
            <button
              key={s}
              className={`bjl-popmenu__item ${s === value ? 'is-active' : ''}`}
              onClick={() => { onChange && onChange(s); setOpen(false); }}
            >
              <span style={{ fontFamily: 'var(--font-mono)' }}>{fmtSpeed(s)}×</span>
              {s === value ? <Icon name="check" /> : null}
            </button>
          ))}
        </span>
      ) : null}
    </span>
  );
}
